import { useDay as useOriginalDay } from '@datepicker-react/hooks';

export const useDay = (
  dayRef,
  date,
  {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover
  }
) => {
  const days = useOriginalDay({
    date,
    focusedDate,
    isDateFocused: isDateFocused || (() => false),
    isDateSelected: isDateSelected || (() => false),
    isDateHovered: isDateHovered || (() => false),
    isDateBlocked: isDateBlocked || (() => false),
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate || (() => false),
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });

  return days;
};
